import { z } from '@harvestiq/zod';
import { zDecimalRequired, zIsoDate } from '@harvestiq/zod';
import {
  CampaignCoverageTier,
  InsureIQPolicyTypes,
  LrpCampaignPdfColumns,
} from '@harvestiq/constants';
import { lrpQuoteSchema } from '@harvestiq/usda-common';

export const lrpQuoteAndPdfResponseSchema = z.object({
  policyType: z.literal(InsureIQPolicyTypes.LRP),
  filename: z.string(),
  fileUrl: z.string(),
  salesEffectiveDate: zIsoDate(),
  targetWeight: zDecimalRequired().nullable(),
  numberOfHead: z.number().int().min(1),
  endorsementLength: z.coerce.number().nullable().optional(),
  coverageTier: z.nativeEnum(CampaignCoverageTier),
  quotes: z.record(z.string(), lrpQuoteSchema.array()),
  quoteColumns: z.array(z.nativeEnum(LrpCampaignPdfColumns)).optional(),
});

export type LrpQuoteAndPdfResponse = z.infer<
  typeof lrpQuoteAndPdfResponseSchema
>;

export const lrpQuoteTemplateDataSchema = lrpQuoteAndPdfResponseSchema.extend({
  message: z.string().optional(),
  unsubscribeURL: z.string().url().optional(),
  campaignId: z.string().uuid().optional(),
});

export type LrpQuoteTemplateData = z.infer<typeof lrpQuoteTemplateDataSchema>;
